import { render, staticRenderFns } from "./TableHeaderItem.vue?vue&type=template&id=f9df2fa8"
import script from "./TableHeaderItem.ts?vue&type=script&lang=ts&external"
export * from "./TableHeaderItem.ts?vue&type=script&lang=ts&external"
import style0 from "./TableHeaderItem.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports